import { render, staticRenderFns } from "./metrics_student_progress_chart.vue?vue&type=template&id=267e5900&scoped=true&"
import script from "./metrics_student_progress_chart.vue?vue&type=script&lang=js&"
export * from "./metrics_student_progress_chart.vue?vue&type=script&lang=js&"
import style0 from "./metrics_student_progress_chart.vue?vue&type=style&index=0&id=267e5900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e5900",
  null
  
)

export default component.exports